import ApiService from "@/common/api.service";

const PATH = "deals";

export const GET_DEALS = "getDeals";
export const GET_DEAL_YEAR_OPTIONS = "getDealYearOptions";
export const GET_DEAL = "getDeal";
export const CREATE_DEAL = "createDeal";
export const UPDATE_DEAL = "updateDeal";
export const UPDATE_DEAL_FIELD = "updateDealField";
export const UPLOAD_DEAL_DOCUMENT = "uploadDealDocument";
export const DELETE_DEAL_DOCUMENT_FILE = "deleteDealDocumentFile";
export const DOWNLOAD_DEAL_DOCUMENT_FILE = "downloadDealDocumentFile";
export const PREVIEW_DEAL_DOCUMENT_FILE = "previewDealDocumentFile";

const actions = {
  [GET_DEALS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [GET_DEAL_YEAR_OPTIONS]() {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, "years")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },
  [GET_DEAL](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },
  [CREATE_DEAL](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },
  [UPDATE_DEAL](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, payload.id, payload.params)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },
  [UPDATE_DEAL_FIELD](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.put(`${PATH}/${payload.dealId}/field`, {
        field: payload.field,
        value: payload.value,
      })
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },
  [UPLOAD_DEAL_DOCUMENT](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.dealId}/documents`, payload.params)
        .then(({ data }) => {
          resolve(Array.isArray(data.data) ? data.data : []);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },
  [DELETE_DEAL_DOCUMENT_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.delete(
        `${PATH}/${payload.dealId}/documents/${payload.documentId}/files/${payload.fileId}`
      )
        .then(() => {
          resolve(true);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },
  [DOWNLOAD_DEAL_DOCUMENT_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.downloadFile(
        `${PATH}/${payload.dealId}/documents/${payload.documentId}/files/${payload.fileId}/download`,
        payload.originalName || payload.name || "download"
      )
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          reject(error?.response?.data || error);
        });
    });
  },
  [PREVIEW_DEAL_DOCUMENT_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.get(
        `${PATH}/${payload.dealId}/documents/${payload.documentId}/files`,
        `${payload.fileId}/preview-url`
      )
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },
};

export default {
  actions,
};
